<template>
  <div class="container">
    <h6>
      Your APNIC Login is not linked to a member account.
    </h6>
    <p>
      Request your APNIC Login and a member account to be linked. <br />Your
      request will be sent to all Corporate Contacts.
    </p>
    <div class="button-wrapper">
      <a
        class="btn btn-primary"
        href="https://resources.apnic.net/auth/nm-landing-page.html"
        >Link existing membership <fa icon="external-link-alt"
      /></a>
    </div>
    <p>
      If you already made the request, then you need to wait until it is
      approved.
    </p>
  </div>
</template>

<script>
export default {
  name: 'NoAccountLinked'
};
</script>

<style lang="scss" scoped>
.container {
  padding: 32px 0;
  text-align: center;
}

h6 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 40px;
}

.button-wrapper {
  margin: 40px 0;
}

p {
  line-height: 24px;
}
</style>
